import { GRENADE } from "./entities.js";
/** "" is the implicit NONE entry and is not listed here. */
export const LOADOUTS = [
    {
        id: "sprinter",
        label: "SPRINTER",
        icon: "🏃",
        desc: "Move 10% faster, always. Take the fight where they aren't.",
        color: "#3fd0ff",
    },
    {
        id: "gunslinger",
        label: "GUNSLINGER",
        icon: "⚡",
        desc: "Reload 35% faster. Win the second half of every duel.",
        color: "#ffd23f",
    },
    {
        id: "vanguard",
        label: "VANGUARD",
        icon: "❤",
        desc: "+25% max health. Survive the opening shot and answer it.",
        color: "#ff5470",
    },
    {
        id: "grenadier",
        label: "GRENADIER",
        icon: "💣",
        desc: "Spawn with 2 grenades every life. Open doors loudly.",
        color: "#9dff00",
    },
];
const BY_ID = new Map(LOADOUTS.map((l) => [l.id, l]));
/** Unknown / "" → null (NONE). Never throws: a client sending a loadout this
 *  build doesn't know just plays without a perk. Mirrors `modifierDef`. */
export function loadoutDef(id) {
    return (id && BY_ID.get(id)) || null;
}
/** Is this a loadout id the server should accept and store? */
export function isLoadoutId(id) {
    return id === "" || (typeof id === "string" && BY_ID.has(id));
}
/** SPRINTER move multiplier. 1.10 not 1.25: prediction and authority both
 *  scale by this, so a large value widens every reconciliation error too. */
export const SPRINTER_SPEED_MUL = 1.1;
/** GUNSLINGER reload multiplier (0.65 = 35% faster). */
export const GUNSLINGER_RELOAD_MUL = 0.65;
/** VANGUARD health bonus, as a FRACTION of the modifier's base pool rather
 *  than a flat +25. Flat would hand GLASS CANNON players +62%, undoing the one
 *  thing that modifier exists to do ("first shot usually wins"). */
export const VANGUARD_HP_FRAC = 0.25;
/** GRENADIER grenades granted on every spawn. */
export const GRENADIER_GRENADES = Math.min(2, GRENADE.maxCarry);
/** Speed multiplier contributed by the loadout, folded into the value both
 *  sides already pass to `stepPlayer`. Kept as a pure helper for the same
 *  reason `modSpeedMul` is: client prediction, the reconcile replay and the
 *  server tick must all reach the identical number or movement drifts. */
export function loadoutSpeedMul(id) {
    return id === "sprinter" ? SPRINTER_SPEED_MUL : 1;
}
/** Reload-duration multiplier contributed by the loadout. Server-only — the
 *  client never computes reload timing, it just mirrors `p.reloading`. */
export function loadoutReloadMul(id) {
    return id === "gunslinger" ? GUNSLINGER_RELOAD_MUL : 1;
}
/** Extra max health on top of the modifier's base pool (already rounded). */
export function loadoutBonusHp(id, baseMaxHp) {
    return id === "vanguard" ? Math.round(baseMaxHp * VANGUARD_HP_FRAC) : 0;
}
/** Grenades handed out on every spawn. */
export function loadoutSpawnGrenades(id) {
    return id === "grenadier" ? GRENADIER_GRENADES : 0;
}
//# sourceMappingURL=loadouts.js.map